"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7291],{

/***/ 87291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProjectImages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Tabs/index.tsx

var Tab = function(param) {
    var tab = param.tab, keynumber = param.keynumber, className = param.className, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        onClick: onClick,
        className: "flex gap-5 w-fit justify-center items-center bg-primary font-normal cursor-pointer py-2 hover:text-primary" + className,
        children: tab
    }, keynumber);
};
/* harmony default export */ var Tabs = (Tab);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./context/useStore.ts + 2 modules
var useStore = __webpack_require__(80094);
;// CONCATENATED MODULE: ./Layout/PreconDetail/Details/Description/ProjectImages/index.tsx





var SitePlan = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9427), __webpack_require__.e(8516)]).then(__webpack_require__.bind(__webpack_require__, 7612));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7612)
            ];
        }
    },
    suspense: true
});
var ProjectGallery = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9427), __webpack_require__.e(7677), __webpack_require__.e(5358)]).then(__webpack_require__.bind(__webpack_require__, 93739));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93739)
            ];
        }
    },
    suspense: true
});
var FloorPlan = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2797), __webpack_require__.e(82)]).then(__webpack_require__.bind(__webpack_require__, 30082));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30082)
            ];
        }
    },
    suspense: true
});
var Index = function(param) {
    var siteplan = param.siteplan, gallery = param.gallery, floorplan = param.floorplan;
    var ref = (0,react.useState)(1), active = ref[0], setActive = ref[1];
    var ref1 = (0,useStore/* default */.Z)(), auth = ref1.auth, setDialog = ref1.setDialog;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-start gap-2 w-full border-b border-gray-400",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-primary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                            className: " text-white !px-4 !py-2 text-sm hover:text-white ".concat(active === 1 ? "mix-blend-screen" : "", " "),
                            keynumber: 1,
                            onClick: function() {
                                setActive(1);
                            },
                            tab: "Project Gallery"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-primary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                            className: " text-white !px-4 !py-2 text-sm hover:text-white ".concat(active === 2 ? "mix-blend-screen" : "", " "),
                            keynumber: 2,
                            onClick: function() {
                                setActive(2);
                            },
                            tab: "Site Plan"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-primary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                            className: " text-white !px-4 !py-2 text-sm hover:text-white ".concat(active === 3 ? "mix-blend-screen" : "", " "),
                            keynumber: 3,
                            onClick: function() {
                                setActive(3);
                            },
                            tab: "Floor Plans"
                        })
                    })
                ]
            }),
            active === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectGallery, {
                    gallery: gallery
                })
            }) : active === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SitePlan, {
                        siteplan: siteplan
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Loading..."
                    })
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        auth.login === false && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute w-full h-full top-0 right-0 z-50 flex justify-center items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rounded-md bg-black text-white bg-opacity-80 px-5 py-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        setDialog({
                                            open: true,
                                            closable: true
                                        });
                                    },
                                    className: "text-base font-normal",
                                    children: "Login Required To View Floor Plan"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: auth.login === false ? "blur" : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FloorPlan, {
                                floorPlan: floorplan
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ProjectImages = (Index);


/***/ })

}]);